import { formatMoney, plural } from '@/lib/format';
import type { ChannexRates, ChannexUsageHotel } from '@/lib/api/types';

const usd = (v: number) => formatMoney(v, 'USD');

/**
 * How Channex prices one property, in a line: one fee per property, or — for
 * an apartment property — one per unit (physical room). Units nobody has read
 * yet are billed at the property fee, and the line says it is a stand-in.
 */
export function pricingLine(
  hotel: Pick<ChannexUsageHotel, 'pricing' | 'unitCount'>,
  rates: Pick<ChannexRates, 'propertyFeeUsd' | 'unitFeeUsd'>,
): string {
  if (hotel.pricing === 'property') return `за объект · ${usd(rates.propertyFeeUsd)}`;
  if (hotel.unitCount === null) return `апартаменты · юниты неизвестны, взято ${usd(rates.propertyFeeUsd)} за объект`;
  return `апартаменты · ${plural(hotel.unitCount, ['юнит', 'юнита', 'юнитов'])} × ${usd(rates.unitFeeUsd)}`;
}
